import { CustomerPartNumber } from "@auer-steel/Services/AuerSteelApiModels";
import { updateCustomerPartNumber as apiUpdate } from "@auer-steel/Services/CustomerPartNumberService";
import { AuerActions } from "@auer-steel/Store/AuerState";
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

export interface UpdateCustomerPartNumberParameter {
    customerPartNumber: CustomerPartNumber;
    onSuccess?: (customerPartNumber: CustomerPartNumber) => void;
    onError?: (customerPartNumber: CustomerPartNumber) => void;
}

type HandlerType = ApiHandler<UpdateCustomerPartNumberParameter, CustomerPartNumber, DispatchProp<AuerActions>>;

export const ExecuteHandler: HandlerType = async props => {
    props.dispatch({
        type: "Pages/MyPartNumbers/ToggleIsSubmitting",
    });
    try {
        props.apiResult = await apiUpdate(props.parameter.customerPartNumber);
    } catch (e) {
        if (isApiError(e) && e.status === 400) {
            return false;
        }
    }

    if (props.apiResult.validationMessage) {
        props.parameter.onError?.(props.apiResult);
        props.dispatch({
            type: "Pages/MyPartNumbers/ToggleIsSubmitting",
        });
        return false;
    }

    if (props.parameter.onSuccess) {
        props.parameter.onSuccess(props.apiResult);
    }
    props.dispatch({
        type: "Pages/MyPartNumbers/ToggleIsSubmitting",
    });
};

export const chain = [ExecuteHandler];

const updateCustomerPartNumber = createHandlerChainRunner(chain, "UpdateCustomerPartNumber");
export default updateCustomerPartNumber;
